// Check if custom element is already defined before defining it
if (!customElements.get('sticky-variant-select')) {
  class StickyProVariantSelect extends HTMLElement {
    constructor() {
      super();
      this.addEventListener("change", this.onStickyVariantChange);
    }
    onStickyVariantChange() {
      this.varOptions = this.querySelector("select");
      //console.log("connected", this.varOptions.value);
      let productForms = document.querySelector(
        `#product-sticky-form-${this.dataset.section}`
      );
      let input = productForms.querySelector('input[name="id"]');
      input.value = this.varOptions.value;
    }
  }
  customElements.define("sticky-variant-select", StickyProVariantSelect);
}

// Check if in Shopify design mode and prevent duplicate event listeners
if (Shopify.designMode && !window.stickyDesignModeListenersAdded) {
  window.stickyDesignModeListenersAdded = true;
  
  document.addEventListener("shopify:section:load", (event) => {
    stickyScroll();
  });
  document.addEventListener("shopify:section:select", (event) => {
    stickyScroll();
  });
  document.addEventListener("shopify:section:deselect", (event) => {
    stickyScroll();
  });
}

// Make stickyScroll function global and prevent multiple scroll listeners
const stickyScroll = () => {
  let stickySelectedVariant = document.querySelector(`#sticky__variant`);
  if (stickySelectedVariant) {
    let stickySelectVairantInput = document.querySelector(
      "#sticky__selected_variant_id"
    );
    stickySelectVairantInput.value = stickySelectedVariant.value;
  }
  
  const BuyButtonForm = document.querySelector(".product_buy_button_form");
  const productStickyWrapper = document.querySelector(".product__sticky");
  
  // Check if elements exist before proceeding
  if (!BuyButtonForm || !productStickyWrapper) return;
  
  // Remove existing scroll listener if it exists
  if (window.stickyScrollHandler) {
    window.removeEventListener("scroll", window.stickyScrollHandler);
  }
  
  // Create the scroll handler function
  window.stickyScrollHandler = function() {
    document.documentElement.style.setProperty(
      "--sticky-bar-height",
      `${productStickyWrapper.clientHeight}px`
    );
    let BuyBUttonOffset = TopOffset(BuyButtonForm);
    let BuyBUttonTopffset = BuyBUttonOffset.top;
    if (window.scrollY > BuyBUttonTopffset) {
      productStickyWrapper.classList.add("sticky");
      document.body.classList.add("sticky__cart");
    } else {
      productStickyWrapper.classList.remove("sticky");
      document.body.classList.remove("sticky__cart");
    }
  };
  
  // Add the scroll listener
  window.addEventListener("scroll", window.stickyScrollHandler);
};

// Initialize only if not already initialized
if (!window.stickyScrollInitialized) {
  window.stickyScrollInitialized = true;
  stickyScroll();
}